export enum Province {
  OURENSE = 32,
  PONTEVEDRA = 36,
  A_CORUNA = 15,
  LUGO = 27
}
